import { combineReducers } from 'redux';
import defaultConfig from './default/reducer';
import custom from './custom/reducer';

export default combineReducers({
  default: defaultConfig,
  custom,
});
